$(document).ready(function() { 

$('.product__info-container').on('click', '.tpo_option-input' ,  function(e) {

    var $this = $(this);

    //recupero i valori di tutti gli input
    //data-selected-index è in formato 1,2,3
    var values = [];
    var index = 0;
    var count = 0;
    $('.tpo_option-input').each(function() {  

        if($(this).attr('name') == $this.attr('name')) {
            index = count;
        }

        values.push($(this).attr("data-selected-index") ? $(this).attr("data-selected-index") : "-1"); 
        count++;
    });
//adesso disabilito i valori che non sono selezionabili  
values.splice(index, 1);  
$(this).parent().parent().find('.tpo_option-type-dropdown-wrapper').children('button').each(function(index ) {
  
    if(values.indexOf(index.toString() ) == -1) {
        $(this).removeClass('tpo_option-type-dropdown-disabled');
    } else {
        $(this).addClass('tpo_option-type-dropdown-disabled');
    } 

});

 

});
 

});